import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './calculator-solar-savings.component.scss';
import { TooltipsService } from '../../services/tooltips.service';
var CalculatorSolarSavings = /** @class */ (function (_super) {
    tslib_1.__extends(CalculatorSolarSavings, _super);
    function CalculatorSolarSavings(element) {
        return _super.call(this, element) || this;
    }
    CalculatorSolarSavings.prototype.init = function () {
        var _this = this;
        TooltipsService.initTooltips();
        this.form = this.element.querySelector('form');
        this.calculateButton = this.element.querySelector('.js-calculator-calculate');
        this.resetButton = this.element.querySelector('.js-calculator-reset');
        this.monthlyRepaymentElement = this.element.querySelector('.js-monthly-repayment');
        this.eskomFeeElement = this.element.querySelector('.eskom-savings');
        this.solarFeeElement = this.element.querySelector('.solar-system-savings');
        this.savingsTitleElement = this.element.querySelector('.js-savings-title');
        this.deficitMessageElement = this.element.querySelector('.js-deficit-message');
        this.setDefaultValues();
        this.setupValidation();
        this.bindEvents();
        // Initialize range input display
        var rangeInput = this.form.querySelector('[name="finance_period"]');
        if (rangeInput) {
            this.updateRangeDisplay(rangeInput);
            rangeInput.addEventListener('input', function () { return _this.updateRangeDisplay(rangeInput); });
        }
    };
    CalculatorSolarSavings.prototype.bindEvents = function () {
        // console.log('Binding events');
        // console.log('Calculate button:', this.calculateButton);
        // console.log('Reset button:', this.resetButton);
        var _this = this;
        if (this.calculateButton) {
            this.calculateButton.addEventListener('click', function (e) {
                // console.log('Calculate button clicked');
                e.preventDefault();
                _this.calculateSavings();
            });
        }
        else {
            // console.error('Calculate button not found');
        }
        if (this.resetButton) {
            this.resetButton.addEventListener('click', function (e) {
                // console.log('Reset button clicked');
                e.preventDefault();
                _this.resetForm();
            });
        }
        else {
            // console.error('Reset button not found');
        }
    };
    CalculatorSolarSavings.prototype.setDefaultValues = function () {
        if (this.form) {
            var inputs = this.form.querySelectorAll('input');
            inputs.forEach(function (input) {
                var defaultValue = input.getAttribute('data-value');
                if (defaultValue) {
                    input.value = defaultValue;
                }
            });
        }
    };
    CalculatorSolarSavings.prototype.setupValidation = function () {
        var _this = this;
        if (this.form) {
            var inputs = this.form.querySelectorAll('input');
            inputs.forEach(function (input) {
                input.addEventListener('input', function () { return _this.validateInput(input); });
            });
        }
    };
    CalculatorSolarSavings.prototype.validateInput = function (input) {
        var value = parseFloat(input.value);
        var name = input.getAttribute('name');
        var validationMessage = input.closest('.input-wrapper, .col').querySelector('.validation-message');
        var showError = function (message) {
            if (validationMessage) {
                validationMessage.textContent = message;
                validationMessage.style.display = 'block';
                input.classList.add('is-invalid');
            }
            input.setCustomValidity(message);
            return false;
        };
        var clearError = function () {
            if (validationMessage) {
                validationMessage.style.display = 'none';
                input.classList.remove('is-invalid');
            }
            input.setCustomValidity('');
            return true;
        };
        // Special handling for deposit which can be 0
        if (name === 'deposit_price') {
            if (isNaN(value)) {
                return showError('This field is required and must be a number');
            }
            if (value < 0 || value > 99999999) {
                return showError('Value must be between 0 and 99,999,999');
            }
            // Check if deposit exceeds system cost
            var systemCostInput = this.form.querySelector('[name="system_cost_price"]');
            if (systemCostInput) {
                var systemCost = parseFloat(systemCostInput.value);
                if (!isNaN(systemCost) && value > systemCost) {
                    return showError('Deposit cannot be greater than system cost');
                }
            }
            return clearError();
        }
        // For other fields, check if value exists and is a number
        if (isNaN(value)) {
            return showError('This field is required and must be a number');
        }
        switch (name) {
            case 'kwh_per_annum':
                if (value < 1 || value > 99999999) {
                    return showError('Value must be between 1 and 99,999,999');
                }
                break;
            case 'tarif_price':
                if (value < 0.1 || value > 5) {
                    return showError('Value must be between 0.1 and 5.0');
                }
                break;
            case 'system_cost_price':
                if (value < 1 || value > 99999999) {
                    return showError('Value must be between 1 and 99,999,999');
                }
                // When system cost changes, validate deposit is still valid
                var depositInput = this.form.querySelector('[name="deposit_price"]');
                if (depositInput) {
                    var depositValue = parseFloat(depositInput.value);
                    if (!isNaN(depositValue) && depositValue > value) {
                        depositInput.classList.add('is-invalid');
                        var depositValidationMessage = depositInput.parentElement.querySelector('.validation-message');
                        if (depositValidationMessage) {
                            depositValidationMessage.textContent = 'Deposit cannot be greater than system cost';
                            depositValidationMessage.style.display = 'block';
                        }
                    }
                }
                break;
            case 'finance_period':
                if (value < 36 || value > 60) {
                    return showError('Value must be between 36 and 60 months');
                }
                break;
            case 'interest_rate':
                // Check for empty value first
                if (input.value.trim() === '') {
                    return showError('Interest rate is required');
                }
                // Check for non-numeric characters
                if (!/^\d*\.?\d*$/.test(input.value)) {
                    return showError('Only numbers and decimal point are allowed');
                }
                // Check decimal places (maximum 1 decimal place)
                if (input.value.includes('.') && input.value.split('.')[1].length > 2) {
                    return showError('Maximum 2 decimal places allowed');
                }
                // Check for valid range with specific messages for edge cases
                if (value <= 0) {
                    return showError('Interest rate must be above 0%');
                }
                if (value < 0.1) {
                    return showError('Minimum interest rate is 0.1%');
                }
                if (value > 100) {
                    return showError('Maximum interest rate is 100%');
                }
                break;
        }
        return clearError();
    };
    CalculatorSolarSavings.prototype.calculateSavings = function () {
        // console.log('Calculate button clicked');
        window.scroll({ top: 0, behavior: "smooth" });
        if (!this.validateAllInputs()) {
            // console.log('Validation failed');
            return;
        }
        var kwhPerAnnum = parseFloat(this.getInputValue('kwh_per_annum'));
        var tariff = parseFloat(this.getInputValue('tarif_price'));
        var systemCost = parseFloat(this.getInputValue('system_cost_price'));
        var deposit = parseFloat(this.getInputValue('deposit_price') || '0');
        var financePeriod = parseFloat(this.getInputValue('finance_period'));
        var interestRate = parseFloat(this.getInputValue('interest_rate'));
        // console.log('Input values:', {
        //     kwhPerAnnum,
        //     tariff,
        //     systemCost,
        //     deposit,
        //     financePeriod,
        //     interestRate
        // });
        // Calculate Eskom cost
        var eskomCostPerAnnum = kwhPerAnnum * tariff;
        // Calculate Solar financing cost
        var loanAmount = systemCost - deposit;
        var monthlyInterestRate = (interestRate / 100) / 12;
        var monthlyPayment = this.calculatePMT(monthlyInterestRate, financePeriod, loanAmount);
        var annualSolarCost = monthlyPayment * 12;
        // console.log('Calculation details:', {
        //     loanAmount,
        //     monthlyInterestRate,
        //     monthlyPayment,
        //     annualSolarCost,
        //     eskomCostPerAnnum
        // });
        // Calculate savings
        var annualSavings = eskomCostPerAnnum - annualSolarCost;
        // Update display
        this.updateDisplay(annualSavings, eskomCostPerAnnum, annualSolarCost);
    };
    CalculatorSolarSavings.prototype.calculatePMT = function (rate, nper, pv) {
        // Make sure we're working with positive values
        var principal = Math.abs(pv);
        if (rate === 0)
            return principal / nper;
        var pvif = Math.pow(1 + rate, nper);
        var pmt = (rate * principal * pvif) / (pvif - 1);
        return pmt;
    };
    CalculatorSolarSavings.prototype.validateAllInputs = function () {
        var _this = this;
        var isValid = true;
        if (this.form) {
            var inputs = this.form.querySelectorAll('input');
            inputs.forEach(function (input) {
                if (!_this.validateInput(input)) {
                    isValid = false;
                }
            });
        }
        return isValid;
    };
    CalculatorSolarSavings.prototype.getInputValue = function (name) {
        if (this.form) {
            var input = this.form.querySelector("[name=\"" + name + "\"]");
            // Handle empty values for deposit specifically
            if (name === 'deposit_price' && input.value === '') {
                return '0';
            }
            return input.value || '0';
        }
        return '0';
    };
    CalculatorSolarSavings.prototype.updateDisplay = function (savings, eskomCost, solarCost) {
        // console.log('Updating display with values:', { savings, eskomCost, solarCost });
        // console.log('Display elements:', {
        //     monthlyRepayment: this.monthlyRepaymentElement,
        //     eskomFee: this.eskomFeeElement,
        //     solarFee: this.solarFeeElement,
        //     savingsTitle: this.savingsTitleElement,
        //     deficitMessage: this.deficitMessageElement
        // });
        if (this.monthlyRepaymentElement && this.eskomFeeElement && this.solarFeeElement &&
            this.savingsTitleElement && this.deficitMessageElement) {
            // Format numbers with thousands separator
            var formatNumber = function (num) {
                return Math.abs(num).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            };
            var isDeficit = savings < 0;
            // Update title and message visibility
            this.savingsTitleElement.textContent = isDeficit ? 'Your estimated annual deficit' : 'Your estimated annual savings';
            this.deficitMessageElement.style.display = isDeficit ? 'block' : 'none';
            // Update the savings/deficit amount
            this.monthlyRepaymentElement.textContent = isDeficit ?
                "-R " + formatNumber(savings) + " p.a" :
                "R " + formatNumber(savings) + " p.a";
            this.eskomFeeElement.textContent = formatNumber(eskomCost) + " p.a";
            this.solarFeeElement.textContent = formatNumber(solarCost) + " p.a";
            // console.log('Display updated successfully');
        }
        else {
            // console.error('One or more display elements not found');
        }
    };
    CalculatorSolarSavings.prototype.resetForm = function () {
        window.scroll({ top: 0, behavior: "smooth" });
        this.setDefaultValues();
        this.monthlyRepaymentElement.textContent = '0.00 p.a';
        this.eskomFeeElement.textContent = '0.00 p.a';
        this.solarFeeElement.textContent = '0.00 p.a';
        this.savingsTitleElement.textContent = 'Your estimated annual savings';
        this.deficitMessageElement.style.display = 'none';
        // Clear all validation messages
        if (this.form) {
            var validationMessages = this.form.querySelectorAll('.validation-message');
            var inputs = this.form.querySelectorAll('input');
            validationMessages.forEach(function (message) {
                message.style.display = 'none';
            });
            inputs.forEach(function (input) {
                input.classList.remove('is-invalid');
                input.setCustomValidity('');
            });
        }
        // Reset range display
        var rangeInput = this.form.querySelector('[name="finance_period"]');
        if (rangeInput) {
            this.updateRangeDisplay(rangeInput);
        }
    };
    CalculatorSolarSavings.prototype.updateRangeDisplay = function (rangeInput) {
        var months = parseInt(rangeInput.value);
        var years = Math.floor(months / 12);
        var rangeDisplay = this.form.querySelector('.calculator-form__title--range');
        var monthsDisplay = this.form.querySelector('[name="finance_period_display"]');
        if (rangeDisplay) {
            rangeDisplay.textContent = months + " Months / " + years + " Years";
        }
        if (monthsDisplay) {
            monthsDisplay.value = months.toString();
        }
    };
    return CalculatorSolarSavings;
}(Base));
export { CalculatorSolarSavings };



//////////////////
// WEBPACK FOOTER
// ./components/calculator-solar-savings/calculator-solar-savings.component.ts
// module id = 1117
// module chunks = 0